import Vue from 'vue'
import Echo from "laravel-echo"
window.Pusher = require('pusher-js');

console.log('Laravel Echo/Pusher-js Providers Loaded...');
var conversationsOpenedList=[]

export default {
       

    initBroadcast(){
    
        var V_authEndpoint = '/broadcasting/auth'
        if (Vue.prototype.$islocalhost) V_authEndpoint = 'https://dev.maia.chat' + V_authEndpoint                

        try{
            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: '839cd3c6becc13098f0b53e02777760648720ca4',
                wsHost: 'websocket.crowdm.it',
                enabledTransports: ['ws','wss'],
                forceTLS: true,
                disableStats: true,
                authEndpoint: V_authEndpoint, //  TODO da eliminare in prod
            });            
        
        }catch(e){
            console.log(e)
        }

    },

    listenForConversationUpdate(conversationId,root) {                    
        conversationsOpenedList.push(conversationId)   

        try{
            window.Echo.private('conversation.'+ conversationId)
            .listen('.conversation.updated', (e) => {                                                                                                                          
                root.$emit("addMessagesFromServer",e.conversation.id);                                                              
            })
            
            window.Echo.private(`conversation.created`)
            .listen('.conversation.created', (e) => {
                root.$emit("checkConversationList",e.conversation.id);                 
            });


        }catch(err){
            console.log(err)
        }

    },

    leaveChannel(conversationId) {            
        
        try{
            window.Echo.leave('conversation.'+conversationId)            
            conversationsOpenedList.splice(conversationsOpenedList.indexOf(conversationId),1)                       
            
        }catch(err){
            console.log(err)
        }

    },
    
    ifChannelIsAlreadyOpen(conversationId){
        return conversationsOpenedList.indexOf(conversationId) > -1 
    }

}
